import { useState, startTransition } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { HomeOutlined, LogoutOutlined, SwapOutlined, SettingOutlined } from '@ant-design/icons'
import { Avatar, Button, Typography, Select } from 'antd'

import { setMode } from '../redux'
import GoBackIcon from './GoBackIcon'
import userImg from '../assets/user.png'
// import SyncIcon from '../assets/Sync-Overview.png'

const Header = () => {
  const { Option } = Select
  const navigate = useNavigate()
  const dispatch = useDispatch()

  let path = window.location.pathname

  const Ai = path === '/ai'
  const location =
    path === '/synopsis-list' || path === '/' || path === '/campaign-list' || path === '/reports'
  // const mode = useSelector((state) => state.generalReducer.mode)

  const id = localStorage.getItem('token')
  const vendorInfo = useSelector((state) => state.generalReducer.vendorInfo)

  const [localMode, setLocalMode] = useState(localStorage.getItem('customer-mode'))

  const Logout = () => {
    localStorage.clear()
    window.location.reload()
    // navigate("/login");
  }

  const modeChangeFn = (mode) => {
    localStorage.setItem('customer-mode', mode)
    dispatch(setMode(mode))
    setLocalMode(mode)
    window.location.reload()
  }

  const pathname = window.location.pathname
  console.log('path', pathname)
  const section = pathname.split('/')[1]
  console.log('section', section)

  return (
    <>
      <header
        className='general-header'
        style={{
          background:
            // path === "/synopsis-list" || path === "/mode-selection"
            location ? 'var(--primary-color)' : Ai ? '#000' : null,
          // background: 'red'
        }}
      >
        <div
          className='vendor-info'
          style={{
            display: 'flex',
            gap: '0.4rem',
          }}
        >
          {section === 'customer-details' ? null : (
            <GoBackIcon color={location ? 'white' : 'black'} />
          )}
          <div style={{ display: Ai && 'none' }}>
            <Avatar
              size={40}
              // style={{ color: "#fff", backgroundColor: "#8A1B6A" }}
              // icon={<UserOutlined />}
              src={vendorInfo?.vendorImage ? vendorInfo?.vendorImage : userImg}
              // src={<UserOutlined />}
            ></Avatar>
          </div>
          <p style={{ color: location ? 'white' : Ai ? 'white' : 'black' }}>
            {vendorInfo?.vendorName}
          </p>
        </div>
        {/* <Link
          to='/'
          style={{
            display: location ? 'none' : null,
          }}
        > */}
        <div
          style={{
            display: location ? 'none' : null,
            cursor: 'pointer',
          }}
          onClick={() => {
            startTransition(() => {
              navigate('/')
            })
          }}
        >
          {Ai ? (
            <Typography.Title level={3} className={Ai ? 'ai-heading' : ''}>
              Hanker
            </Typography.Title>
          ) : (
            <Typography.Title level={2}>Hanker</Typography.Title>
          )}
        </div>
        {/* </Link> */}
        <div className='Buttons'>
          {path.includes('synopsis') && (
            <Button
              style={{
                display: location ? 'none' : null,
              }}
              type='primary'
              icon={<HomeOutlined />}
              onClick={() => {
                navigate('/')
              }}
            >
              Dashboard
            </Button>
          )}
          {path.includes('user-details') ||
          path.includes('offline-user') ||
          path.includes('login') ? null : (
            <>
              {/* <Dropdown overlay={items} trigger={['click']}>
                <div className='switch-mode-btn'>
                  {localMode == 'offline'
                    ? 'Offline'
                    : localMode == 'ecommerce'
                    ? 'Ecommerce Local'
                    : localMode == 'ecommerceint'
                    ? 'Ecommerce International'
                    : 'Offline'}
                </div>
              </Dropdown> */}
              {!location && (
                <Select
                  value={localMode || 'offline'}
                  onChange={(e) => modeChangeFn(e)}
                  style={{ minWidth: '150px' }}
                  className='switch-mode-btn'
                >
                  {vendorInfo?.login_offline && <Option value='offline'>Offline</Option>}
                  {vendorInfo?.login_ecommerce && (
                    <Option value='ecommerce'>Ecommerce Local</Option>
                  )}
                  {vendorInfo?.login_ecommerce_intl && (
                    <Option value='ecommerceint'>Ecommerce International</Option>
                  )}
                </Select>
              )}

              {/* {!location && (
                <Button
                  type='primary'
                  className='btn-primary btn-primary-glow header-btn'
                  onClick={() => navigate('/sync-offline')}
                  icon={<img src={SyncIcon} alt='Sync-Overview' style={{ height: '30px' }} />}
                >
                  Sync Overview
                </Button>
              )} */}

              {!location && (
                <Button
                  type='primary'
                  onClick={() => window.open('http://54.176.190.27/hankering', '_blank')}
                  icon={<SwapOutlined />}
                  className='btn-primary btn-primary-glow header-btn'
                >
                  Hankering
                </Button>
              )}
            </>
          )}
          <Button
            type='primary'
            onClick={() => navigate('/settings')}
            icon={<SettingOutlined />}
            className='btn-primary btn-primary-glow header-btn'
          >
            Settings
          </Button>
          {id ? (
            <Button
              type='primary'
              onClick={() => Logout()}
              icon={<LogoutOutlined />}
              className='btn-primary btn-primary-glow header-btn'
            >
              Logout
            </Button>
          ) : (
            <div />
          )}
        </div>
      </header>
      {/* <marquee
        style={{ marginTop: "100px" }}
        width="100%"
        heigth="10px"
        direction="right"
      >
        Sorry for the inconvenience. We&rsquo;re performing some maintenance at
        the moment. we&rsquo;ll be back up shortly!
      </marquee> */}
    </>
  )
}

export default Header
